const getMultiSelectOptions = state => state.lead.filterTable.multiSelectOptions;
const getCheckedStatus = state => state.lead.filterTable.checkedStatus;
const getShowDownloadReportModal = state => state.lead.filterTable.showDownloadReportModal;
const getSortOptions = state => state.lead.filterTable.sortOptions;
const getSortOptionSelected = state => state.lead.filterTable.sortOptionSelected;

export { getMultiSelectOptions, getCheckedStatus, getShowDownloadReportModal, getSortOptionSelected, getSortOptions };
